import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_f7faff = setTheme(({ theme }) => `background-color: ${theme.colors.color_f7faff}`);
